// extracted by mini-css-extract-plugin
export var discard = "_2j-4";
export var muiTooltipTooltip = "_2j-6";
export var notificationBar = "_2j-3";
export var notificationContainer = "_2j-2";
export var saveButtonHoverSlotWrapper = "_2j-5";
export var show = "_2j-1";
export var spacer = "_2j-0";